import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { Button, TextButton } from '../../../../components/common';
import { MainSource } from '../../../../constants/Source';
import { RouteBuilder } from '../../../../utils/RouteHelpers';
import { IOuter } from '../EmptyState.types';

export const GoToSiteFilesButton: FC<IOuter> = () => {
  const history = useHistory();
  const handleClick = useCallback(() => history.push(RouteBuilder.Source(MainSource.SiteFiles)), [history]);

  const isTextButton = window.isNewColorsBrandingEnabled;

  const Component = isTextButton ? TextButton : Button;

  return (
    <Component
      size="small"
      skin="standard"
      priority="secondary"
      onClick={handleClick}
      dataHook="go-to-site-files-button"
    >
      <FormattedMessage id="empty-state.try-again" />
    </Component>
  );
};
